import { render, staticRenderFns } from "./PcPcmTapFlc.vue?vue&type=template&id=1167a0cc&"
import script from "./PcPcmTapFlc.vue?vue&type=script&lang=js&"
export * from "./PcPcmTapFlc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports